import { render, staticRenderFns } from "./SwiperTypeOne.vue?vue&type=template&id=01161f83&scoped=true&"
import script from "./SwiperTypeOne.vue?vue&type=script&lang=js&"
export * from "./SwiperTypeOne.vue?vue&type=script&lang=js&"
import style0 from "./SwiperTypeOne.vue?vue&type=style&index=0&id=01161f83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01161f83",
  null
  
)

export default component.exports